export const getIp = async (): Promise<string> => {
  try {
    const response = await fetch(process.env.RAZZLE_IP_SERVICE);
    const data = await response.json();
    return data?.ip;
  } catch (err) {
    throw new Error(`Unable to retrieve client IP : ${err}`);
  }
};
